import { render, staticRenderFns } from "./floating-window.vue?vue&type=template&id=6fbca0f4&scoped=true&"
import script from "./floating-window.vue?vue&type=script&lang=ts&"
export * from "./floating-window.vue?vue&type=script&lang=ts&"
import style0 from "./floating-window.vue?vue&type=style&index=0&id=6fbca0f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbca0f4",
  null
  
)

export default component.exports